import { Pipe, PipeTransform } from '@angular/core';

import { userActiveProductIds } from 'src/app/user/constants/constants';

@Pipe({ name: 'userActiveProductIds', standalone: true })
export class UserActiveProductIdsPipe implements PipeTransform {
  transform(section, userData, options = {}) {
    return userActiveProductIds(section, userData, options);
  }
}
